import React from 'react';

const TagList = ({ tags, className = '' }) => {
  if (!tags?.length) return null;
  return (
    <div className={['tag-list', className].filter(Boolean).join(' ')}>
      {tags.map((tag, i) => <span key={i} className="tag">{tag}</span>)}
    </div>
  );
};

export default TagList;
